import { AJOUTE_URL_CLIENT, SUPRIMER_URL_CLIENT } from '../types/typeUrlClient';
const urlClient = [];
const UrlClientReducer = (state = urlClient, action) => {
    if (localStorage.getItem('urlClientSociete')) {
        state = localStorage.getItem('urlClientSociete');
    }
    switch (action.type) {
        case AJOUTE_URL_CLIENT:
            state = action.payload;
            return state;
            break;
        case SUPRIMER_URL_CLIENT:
            return state = [];
        default:
            return state;

    }
}

export default UrlClientReducer;